const ThumbTestimonialsIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width={17} height={18} fill='none'>
    <path
      fill='#5D5DFF'
      d='M8.426.518a8.33 8.33 0 1 0 0 16.66 8.33 8.33 0 0 0 0-16.66Zm-2.04 10.567a.814.814 0 1 1-1.63 0V7.613a.814.814 0 1 1 1.63 0v3.472Zm5.752-.059c0 .637-.372.865-1.009.865H8.201a1.152 1.152 0 0 1-1.152-1.153v-2.88s-.058-.48.473-.93c.3-.254.745-.74 1.056-1.33.619-1.172.988-1.514 1.27-1.422 1.043.338.521 1.884.185 2.53h.952c.636 0 1.153.515 1.153 1.152v3.168Z'
    />
  </svg>
)
export default ThumbTestimonialsIcon
